import { fg } from '@atlaskit/platform-feature-flags';
import getDocument from './getDocument';
function getRelativeUrl(absoluteUrl) {
  var url = new URL(absoluteUrl);
  return "".concat(url.pathname).concat(url.search).concat(url.hash);
}
export function mapToPathBasedUrl(url) {
  if (fg('platform_media_path_based_route')) {
    var _getDocument;
    var parsedUrl = new URL(url);
    parsedUrl.pathname = "/media-api".concat(parsedUrl.pathname);
    var location = (_getDocument = getDocument()) === null || _getDocument === void 0 ? void 0 : _getDocument.location;

    // in this case we are most likely in SSR / a non browser environment so just return a relative URL
    if (!location) {
      return getRelativeUrl(parsedUrl.toString());
    }
    parsedUrl.host = location.host;
    return parsedUrl.toString();
  }
  return url;
}
export function mapRetryUrlToPathBasedUrl(url) {
  var _getDocument$location, _getDocument2;
  var parsedUrl = new URL(url);
  parsedUrl.host = (_getDocument$location = (_getDocument2 = getDocument()) === null || _getDocument2 === void 0 ? void 0 : _getDocument2.location.host) !== null && _getDocument$location !== void 0 ? _getDocument$location : '';

  // remove CDN from the URL for retry if it exists
  var pathname = parsedUrl.pathname;
  if (pathname.endsWith('/cdn')) {
    parsedUrl.pathname = pathname.replace('/cdn', '');
  }
  parsedUrl.pathname = "/media-api".concat(parsedUrl.pathname);
  return parsedUrl;
}